export default __webpack_public_path__ + "locales/pt/Files.json?hash=77e626fc32fe338b00ee8f84dc5b9640";